import React from 'react';
import Spinner from '../../../loaders/Spinner';
import './EmojiPopupContentLoading.scss';

const EmojiPopupContentLoading = ({ style }: { style?: React.CSSProperties }) => (
    <div style={style} className="EmojiPopupContentLoading">
        <Spinner show />
    </div>
);

export default EmojiPopupContentLoading;
